import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {ForgotPasswordConfirm, ForgotPasswordConfirmParams} from 'domain/usecases';

export class RemoteForgotPasswordConfirm implements ForgotPasswordConfirm {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<void>,
	) {}

	async forgotPasswordConfirm({signal, ...params}: ForgotPasswordConfirmParams): Promise<void> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
